// ISO 3166-1 Country codes as of Aug 2022
export const GEO_REGIONS = [
  {
    name: 'GB',
    label: 'United Kingdom',
    countryCodes: ['GB', 'UK', 'IM', 'GG', 'JE'],
  },
  {
    name: 'NA',
    label: 'North America',
    countryCodes: [
      'US',
      'CA',
      'MX',
      'BS',
      'BB',
      'BZ',
      'BM',
      'KY',
      'CU',
      'PR',
      'PM',
      'UM',
      'TC',
      'VG',
      'VI',
    ],
  },
  {
    name: 'AU',
    label: 'Australia',
    countryCodes: [
      'AU',
      'AS',
      'CX',
      'CC',
      'FJ',
      'PF',
      'HM',
      'KI',
      'NR',
      'NC',
      'NF',
      'PG',
      'WS',
      'SB',
      'TK',
      'TO',
      'TV',
      'VU',
      'WF',
    ],
  },
  {
    name: 'NZ',
    label: 'New Zealand',
    countryCodes: ['NZ', 'CK', 'NU'],
  },
  {
    name: 'SA',
    label: 'South America',
    countryCodes: [
      'AI',
      'AG',
      'AR',
      'AW',
      'BO',
      'BQ',
      'BR',
      'CL',
      'CO',
      'CR',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'UY',
      'VE',
    ],
  },
  {
    name: 'EU',
    label: 'Europe',
    countryCodes: [
      'AX',
      'AL',
      'AD',
      'AM',
      'AT',
      'AZ',
      'BY',
      'BE',
      'BA',
      'BG',
      'HR',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FO',
      'FI',
      'FR',
      'GE',
      'DE',
      'GI',
      'GR',
      'GL',
      'VA',
      'HU',
      'IE',
      'IS',
      'IL',
      'IT',
      'LV',
      'LT',
      'LI',
      'LU',
      'MK',
      'MC',
      'MT',
      'MD',
      'ME',
      'NL',
      'NO',
      'PL',
      'PT',
      'RO',
      'RU',
      'SM',
      'RS',
      'SK',
      'SI',
      'ES',
      'SJ',
      'SE',
      'CH',
      'TR',
      'UA',
    ],
  },
  {
    name: 'AS',
    label: 'Asia',
    countryCodes: [
      'AF',
      'BH',
      'BD',
      'BT',
      'IO',
      'BN',
      'KH',
      'CN',
      'KM',
      'GU',
      'HK',
      'IN',
      'ID',
      'IR',
      'IQ',
      'JP',
      'JO',
      'KZ',
      'KP',
      'KR',
      'KW',
      'KG',
      'LA',
      'LB',
      'MO',
      'MY',
      'MV',
      'MH',
      'FM',
      'MN',
      'MM',
      'NP',
      'MP',
      'OM',
      'PK',
      'PW',
      'PS',
      'PH',
      'QA',
      'SA',
      'SG',
      'LK',
      'SY',
      'TW',
      'TJ',
      'TH',
      'TL',
      'TM',
      'AE',
      'UZ',
      'VN',
      'YE',
    ],
  },
  {
    name: 'AF',
    label: 'Africa',
    countryCodes: [
      'DZ',
      'AO',
      'BJ',
      'BW',
      'BF',
      'BI',
      'CV',
      'CM',
      'CF',
      'TD',
      'CD',
      'CG',
      'CI',
      'DJ',
      'EG',
      'GQ',
      'ER',
      'SZ',
      'ET',
      'GA',
      'GM',
      'GH',
      'GN',
      'GW',
      'KE',
      'LS',
      'LR',
      'LY',
      'MG',
      'MW',
      'ML',
      'MR',
      'MU',
      'YT',
      'MA',
      'MZ',
      'NA',
      'NE',
      'NG',
      'RE',
      'RW',
      'ST',
      'SN',
      'SC',
      'SL',
      'SO',
      'ZA',
      'SS',
      'SD',
      'TZ',
      'TG',
      'TN',
      'UG',
      'EH',
      'ZM',
      'ZW',
    ],
  },
  {
    name: 'XX',
    label: 'Other',
    countryCodes: ['AQ', 'BV', 'TF', 'PN', 'SH'],
  },
];

export const geoRegionFromCountryCode = (countryCode) => {
  const geoRegionDict = GEO_REGIONS.find((r) =>
    r.countryCodes.includes(countryCode.toUpperCase()),
  );
  if (!geoRegionDict) {
    return 'XX';
  }
  return geoRegionDict.name;
};

export const countryCodeFromGeoRegion = (geoRegion) => {
  switch (geoRegion) {
    case 'NA':
      return 'US';

    case 'GB':
      return 'GB';

    case 'AU':
      return 'AU';

    case 'NZ':
      return 'NZ';

    case 'SA':
      return 'AR';

    case 'EU':
      return 'NL';

    case 'AS':
      return 'HK';

    case 'AF':
      return 'ZA';

    case 'XX':
      return 'GB';

    default:
      return 'GB';
  }
};
